<template>
  <div class="app-main-inner-row extension-conditions-form">
    <el-form ref="basicForm" inline label-position="left">
      <el-form-item
        v-permission="['filter_ACTBilling_arCharges','filter_ACTBilling_apCharges','filter_ACTBilling_allCharges']"
        :label="$t('CargoMsg.Cargo_PaymentReceiveMethodP')"
      >
        <el-radio-group v-model="ownConditions.isAr" :disabled="enabledBillType" no="1">
          <el-radio v-permission="['filter_ACTBilling_arCharges']" :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
          <el-radio v-permission="['filter_ACTBilling_apCharges']" :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          <el-radio v-permission="['filter_ACTBilling_allCharges']" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-permission="['filter_ACTBilling_allRegionalCharges','filter_ACTBilling_overseaCharges','filter_ACTBilling_localCharges']"
        :label="$t('CargoMsg.Cargo_ChargeTypeP')"
      >
        <el-radio-group v-model="ownConditions.oversea" :disabled="enabledBillType" no="2">
          <el-radio v-permission="['filter_ACTBilling_localCharges']" :label="0">{{ $t('CargoMsg.Cargo_Domestic') }}</el-radio>
          <el-radio v-permission="['filter_ACTBilling_overseaCharges']" :label="1">{{ $t('CargoMsg.Cargo_International') }}</el-radio>
          <el-radio v-permission="['filter_ACTBilling_allRegionalCharges']" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_ReconciliationTypeP')">
        <el-radio-group v-model="ownBillType" :disabled="enabledBillType" no="3" @change="onBillTypeChange">
          <el-radio label="charge">{{ $t('CargoMsg.Cargo_ByFee') }}</el-radio>
          <el-radio label="job">{{ $t('CargoMsg.Cargo_ByJob') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="useOrderCenterMode" label-width="0">
        <el-checkbox v-model="ownConditions.internalCharge" :disabled="enabledBillType" no="4">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_BusinessDateP')">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="0">
              <el-date-picker
                v-model="ownConditions.businessDate[0]"
                no="5"
                type="date"
                style="width:100%;"
                :clearable="false"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :disabled="enabledBillType"
              /></el-form-item>
          </el-col>
          <el-col :span="1"><span style="font-size: 12px;">{{ $t('CargoMsg.Cargo_To') }}</span></el-col>
          <el-col :span="8">
            <el-form-item label-width="0">
              <el-date-picker
                v-model="ownConditions.businessDate[1]"
                no="6"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :disabled="enabledBillType"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7" style="padding-left: 5px">
            <el-form-item label-width="0">
              <el-checkbox v-model="allowTwoyearOutside" :disabled="enabledBillType" no="7">{{ $t('WriteOff.queryLotsOfData') }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import lodash from 'lodash'
import moment from 'moment'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  props: {
    source: { type: String, required: true },
    billType: { type: String, required: true },
    enabledBillType: { type: Boolean, default: false },
    conditions: {
      type: Object, required: true
    }
  },
  data() {
    return {
      ownBillType: this.billType,
      allowTwoyearOutside: false,
      ownConditions: {
        isAr: 1, // 应收/应付
        advance: -1, //  是否垫付
        oversea: 0, // （国内/国外）
        hasInvoice: -1, // 是否开票
        hasDiffCharge: -1, // 是否关联差异对冲费用
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [], // 费用确认状态
        exceptKeys: [], // 在查询中想要例外的对象列表
        hasBillPayment: -1, // 是否关联付款申请
        hasBilling: -1, // 是否关联账单
        isShowWriteOff: true, // 是否过滤全部核销数据
        shared: 0, // 是否分摊费用
        businessDate: [], // 业务日期,
        customConditions: [], // 自定义约束条件
        internalCharge: false // 内结
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
    allowTwoyearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Invoice.invoice_unlockBusinessDateQuery'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' }).catch(() => {
          this.allowTwoyearOutside = false
        })
      } else {
        this.ownConditions.businessDate[0] = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    billType(val) {
      this.ownBillType = val
    }
  },
  created() {
    this.ownConditions = lodash.cloneDeep({ ...this.ownConditions, ...this.conditions })
    if (['reconciliationByJob', 'reconciliationByCharge'].includes(this.source)) {
      const arCharges = this.$checkPermission(['filter_ACTBilling_arCharges'])
      const apCharges = this.$checkPermission(['filter_ACTBilling_apCharges'])
      const allCharges = this.$checkPermission(['filter_ACTBilling_allCharges'])
      const allRegionalCharges = this.$checkPermission(['filter_ACTBilling_allRegionalCharges'])
      const overseaCharges = this.$checkPermission(['filter_ACTBilling_overseaCharges'])
      const localCharges = this.$checkPermission(['filter_ACTBilling_localCharges'])
      if (arCharges) {
        this.ownConditions.isAr = 1
      } else if (!arCharges && apCharges) {
        this.ownConditions.isAr = 0
      } else if (!arCharges && !apCharges && allCharges) {
        this.ownConditions.isAr = -1
      }
      if (localCharges) {
        this.ownConditions.oversea = 0
      } else if (!localCharges && overseaCharges) {
        this.ownConditions.oversea = 1
      } else if (!overseaCharges && !localCharges && allRegionalCharges) {
        this.ownConditions.oversea = -1
      }
    }
    const { businessDate } = this.ownConditions
    this.ownConditions.businessDate = [businessDate[0] || moment().subtract(2, 'y').format('yyyy-MM-DD'), businessDate[1] || '']
  },
  methods: {
    disabledDate(currDate) {
      if (!this.allowTwoyearOutside) {
        const beforeTwoyear = moment().subtract(2, 'y')
        return currDate < beforeTwoyear
      }
      return false
    },
    onBillTypeChange(val) {
      this.$emit('update:billType', val)
    }
  }
}
</script>
<style lang="scss">
.extension-conditions-form {
  .el-col {
    margin-top: 0!important;
  }
}
</style>
